import type { Container } from 'pixi.js';
import { Point } from 'pixi.js';

export function getWorldScale(originContainer: Container): { x: number; y: number } {
  let container: Container | null = originContainer;
  let worldScaleX = 1;
  let worldScaleY = 1;

  while (container) {
    worldScaleX *= container.scale.x;
    worldScaleY *= container.scale.y;
    container = container.parent;
  }
  return { x: worldScaleX, y: worldScaleY };
}

export function setContainerParent(container: Container, parent: Container, point: Point = new Point()): void {
  const parentScale = getWorldScale(parent);
  const containerScale = getWorldScale(container);
  const transformedPos = parent.toLocal(container.toGlobal(point.set(0, 0), point), undefined, point);
  parent.addChild(container);
  container.x = transformedPos.x;
  container.y = transformedPos.y;
  container.scale.x = containerScale.x / parentScale.x;
  container.scale.y = containerScale.y / parentScale.y;
}
